import React, { useState, useReducer, useEffect, useRef } from "react";
import { Button, Grid, Modal, Icon, Popup, Label } from "semantic-ui-react";
import {
  initialState,
  reducer,
  ACTION,
} from "../../../Reducer/InitialStateReducer";

import { server } from "../../../App";
import axios from "axios";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { Editor } from "@tinymce/tinymce-react";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { selectCounters, Certificat_Counter_Reducer } from "../../../features/counter/counterSlice";

function Medicaments(props) {
  const dispatchRedux = useDispatch();
  const CountersState = useSelector(selectCounters);
  const [state, dispatch] = useReducer(reducer, initialState);
  const [, setGridApi] = useState(null);
  const [, setGridColumnApi] = useState(null);

  const { ID } = props;

  const editorRef = useRef(null);

  const description = state.description;
  // const fk_id_patient = state.fk_id_patient;
  const idcertificat = state.idcertificat;

  const columnDefs2 = [
    {
      headerName: "date",
      field: "date",
      editable: false,
      hide: true,
    },
    {
      headerName: "description",
      field: "description",
      editable: false,
      hide: true,
    },
    {
      headerName: "fk_id_patient",
      field: "fk_id_patient",
      editable: false,
      hide: true,
    },
    {
      headerName: "idcertificat",
      field: "idcertificat",
      editable: false,
      hide: true,
    },
    {
      headerName: "date",
      field: "dateLisible",
      checkboxSelection: true,
    },

    // 1ere sous catégorie
  ];

  const defaultColDef2 = {
    suppressMovable: true,
    sortable: true,
    // editable: true,
    // cellEditor: 'agLargeTextCellEditor',
    maxLength: 255,
    flex: 1,
    // filter stuff
    filter: true,
    // floatingFilter: true,
    // suppressMenu: true,
    // end of filter stuff
    minWidth: 100,
    // resizable: true,
    // tooltipComponent: 'customTooltip',
    filterParams: {
      newRowsAction: "keep",
      // buttons: ['apply', 'clear'],
    },
    resizable: true,
    cellClass: "cell-wrap-text",
    autoHeight: true,
  };

  async function getOneUser() {
    await axios
      .get(`${server}Consultation/getcerts/${ID}`, {
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
      .then((response) => {
        dispatchRedux(Certificat_Counter_Reducer(response.data.length));
        dispatch({ type: ACTION.FETCH_SUCCESS2, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: ACTION.FETCH_ERROR, payload: error.response });
      });
  }

  useEffect(() => {
    getOneUser();
  }, [state.open]);

  const onGridReady = (params) => {
    setGridColumnApi(params.columnApi);
    setGridApi(params.api);
    // params.api.setRowData(state?.rowData2);
  };

  const onSelectionChanged2 = (e) => {
    if (e.api.getSelectedRows()[0] === undefined) {
      const emptyCheckbox = {
        date: "",
        dateLisible: "",
        description: "",
        fk_id_patient: "",
        idcertificat: "",
      };
      dispatch({
        type: ACTION.ORDONANCE_CERT_HISTORIC,
        value: emptyCheckbox,
      });
    } else {
      let clientArray = e.api.getSelectedRows()[0];

      // console.log(clientArray);

      dispatch({
        type: ACTION.ORDONANCE_CERT_HISTORIC,
        value: clientArray,
      });
    }
  };

  // console.log({ date, dateLisible, description, fk_id_patient, idcourrier });

  async function UpdateCourrier() {
    const ValuesToCreate = {
      idcertificat,
      fk_id_patientConsul: ID,
      description: editorRef.current.getContent(),
    };
    await axios({
      method: "put",
      responseType: "json",
      url: `${server}Consultation/updatecert`,
      data: ValuesToCreate,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then((response) => {
        // syncData(response.data);
        getOneUser();
        toast.success("Success", {
          position: toast.POSITION.TOP_LEFT,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  }

  const handleRemoveItem1 = async () => {
    axios({
      method: "DELETE",
      responseType: "json",
      url: `${server}Consultation/DeleteOnecert/${idcertificat}/${ID}`,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then(() => {
        // dispatch({ type: ACTION.DELETE_SUCCESS })
        getOneUser();
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };

  let Contents = (
    <div>
      <Editor
        // apiKey="4wmks1hxrd175lnu674946w8nb95pzv263exeq2v73z02al0"
        tinymceScriptSrc={process.env.PUBLIC_URL + "/tinymce/tinymce.min.js"}
        onInit={(evt, editor) => (editorRef.current = editor)}
        initialValue={description}
        init={{
          // selector: "textarea",
          branding: false,
          height: "70vh",
          menubar: false,
          plugins: [
            "advlist autolink lists link image charmap print preview anchor",
            "searchreplace visualblocks code fullscreen",
            "insertdatetime media table paste code help ",
            "print",
          ],
          toolbar:
            "undo redo | formatselect | " +
            "bold italic underline print forecolor backcolor | alignleft aligncenter " +
            "alignright alignjustify | bullist numlist outdent indent | ",
          content_style:
            "@page { size: A5;margin-top: 3.8cm; margin-bottom: 2.2cm; margin-left:0.25cm; margin-right:0.25cm; } body{font-size:16px} ",
        }}
      />
    </div>
  );

  // console.log(state.rowData2.length)

  return (
    <>
      <Popup
        content="Historique Certificats"
        trigger={
          <Button

            onClick={() => dispatch({ type: ACTION.OPEN, size: "large" })}
          >
            <Icon name="history" size="large" className="centerIcon" />
            {CountersState?.Certificat_Counter === 0 ? null :
              <Label color='red' className="floatingnumber">
                {CountersState?.Certificat_Counter}
              </Label>

            }

          </Button>
        }
      />

      <Modal
        size={state.size}
        open={state.open}
        onClose={() => dispatch({ type: ACTION.CLOSE })}
      // className="lunettesModal"
      >
        <Modal.Header className="center3columnheaders">
          Historique des Certificats
          <Button
            floated="right"
            color="blue"
            onClick={() => dispatch({ type: ACTION.CLOSE })}
          >
            Retour <Icon className="leftSpace" name="reply" />
          </Button>
          <Button
            floated="right"
            color="green"
            onClick={() => UpdateCourrier()}
          >
            Modifier
          </Button>
        </Modal.Header>
        <Modal.Content>
          <Grid>
            <Grid.Column width={12}>{Contents}</Grid.Column>

            <Grid.Column width={4}>
              <div
                id="myGrid"
                className="ag-theme-alpine"
                style={{
                  height: "50vh",
                  width: "100%",
                }}
              >
                <AgGridReact
                  rowData={state?.rowData2}
                  // rowData={state?.rowData2 ? state?.rowData2 : []}
                  // rowData={[]}
                  animateRows={true}
                  sortingOrder={["desc", "asc", null]}
                  onGridReady={onGridReady}
                  columnDefs={columnDefs2}
                  defaultColDef={defaultColDef2}
                  rowSelection={"single"}
                  onSelectionChanged={onSelectionChanged2}
                  undoRedoCellEditing={true}
                  undoRedoCellEditingLimit={40}
                // onCellValueChanged={onCellValueChanged2}
                ></AgGridReact>
              </div>
              <br />
              <Grid.Row>
                {idcertificat ? (
                  <>
                    {/* <Button positive onClick={() => UpdateLunettesAttributes()} icon>
                                            <Icon name='save' />
                                        </Button> */}
                    {/* <button onClick={() => onRemoveSelected()}>Remove Selected</button> */}
                    <Button
                      negative
                      onClick={() => handleRemoveItem1()}
                      floated="right"
                      icon
                    >
                      <Icon name="delete" />
                    </Button>
                  </>
                ) : (
                  <>
                    {/* <Button disabled positive onClick={() => UpdateLunettesAttributes()} icon>
                                            <Icon name='save' />
                                        </Button> */}

                    <Button disabled negative floated="right" icon>
                      <Icon name="delete" />
                    </Button>
                  </>
                )}
              </Grid.Row>
            </Grid.Column>
          </Grid>
        </Modal.Content>
      </Modal>
    </>
  );
}

export default Medicaments;
